export default "__VITE_ASSET__D6T6yTjS__"